import Codes from "../../errorCodes/regions"

export default function regionErrorHandler(errorCode: string) {
  switch (errorCode) {
    case Codes.PBREGEmptyField:
      return "errors.PBREGEmptyField"
    default:
      return ""
  }
}
